import { IAdFoxBannerOnLoadData } from '@cian/adfox-component';
import * as React from 'react';
import { useSelector } from 'react-redux';

import * as styles from './TgbBottomBannersContainer.css';
import { AdfoxBanner } from '../../../components/AdfoxBanner';
import { selectIsAgent } from '../../../selectors';
import { useAdfoxBannerActions } from '../hooks/useAdfoxBannerActions';
import { useAdfoxPuids } from '../hooks/useAdfoxPuids';

const ADFOX_PARAMETERS = {
  p1: 'crtmn',
  p2: 'fkhh',
};

const ADFOX_LAZY_LOAD: React.ComponentProps<typeof AdfoxBanner>['lazyLoad'] = {
  fetchMargin: 0.5,
  mobileScaling: 1,
};

export const TgbBottomBannersContainer: React.FC = () => {
  const isAgent = useSelector(selectIsAgent);
  const adfoxPuids = useAdfoxPuids();
  const adfoxParameters = React.useMemo(
    () => ({
      ...adfoxPuids,
      ...ADFOX_PARAMETERS,
    }),
    [adfoxPuids],
  );
  const { onClick, onLoad } = useAdfoxBannerActions();

  const handleLoad = React.useCallback(
    ({ bundleParams: { bannerId } }: IAdFoxBannerOnLoadData) => {
      onLoad(bannerId);
    },
    [onLoad],
  );

  return (
    <div className={styles['container']}>
      {Array(3)
        .fill(null)
        .map((_, i) => (
          <AdfoxBanner
            key={`banner_${i}`}
            className={styles['banner']}
            disableYan={isAgent}
            params={adfoxParameters}
            minHeight="200px"
            minWidth="33%"
            lazyLoad={ADFOX_LAZY_LOAD}
            onLoad={handleLoad}
            onClick={onClick}
          />
        ))}
    </div>
  );
};
